// extracted by mini-css-extract-plugin
export default {"MainCont":"Assembly_MainCont__JSJjI","LeftCont":"Assembly_LeftCont__Bc8ch","RightCont":"Assembly_RightCont__H4u7c"};